import useCopyClipboard from './components/use-copy-clipboard';

export default useCopyClipboard;

export { useCopyClipboard };
